<header>
    <div *ngIf="userId==null">
        <!-- <img src="./assets/login-header.jpg" style="width: 100%;"> -->
        <div class="row">
            <div class="col-md-12" style="padding: 0;" style="background-image: url('./../../../assets/bg.png');background-repeat: no-repeat;background-size: cover;">
                <img src="./../../../assets/Logo2.png" alt="Dental Council of India" title="Dental Council of India">
                <!-- <a href="https://rashtragaan.in/">         
                    <img src="./../../../assets/Logo75.png" class="tabView" alt="Dental Council of India" title="Dental Council of India">
                </a>
                <img src="./../../../assets/logoembdig.png" alt="Dental Council of India" title="Dental Council of India"> -->
            <img src="./../../../assets/Digital_India_logo.png" alt="Dental Council of India" title="Dental Council of India"
            style="position: absolute; top: 10px; right: 20px; height: 70px;">
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="row">
                    <div class="col-md-4">
                        <h5 class="headingValue">Unique IDR Registration Form</h5>
                    </div>
                    <div class="col-md-8 text-right">
                        <!-- <button type="button" *ngIf="showUpdateButton" class="btn btn-info backbtn" style="cursor: pointer;"
                        data-toggle="modal" data-target="#myModall"><span>

                        </span>&nbsp;Response To Clarification</button>&nbsp; -->
                        <button type="button" (click)="back()" class="btn btn-primary backbtn"
                            style="cursor: pointer;"><span><i class="fas fa-angle-left"></i></span>&nbsp;Back</button>
                    </div>
                </div>
                <hr>
                <form [formGroup]="uidrRegistrationForm">
                    <div class="row">
                        <div class="col-md-6">
                            <h5 class="headingValue">Personal Information</h5>
                        </div>
                    </div>
                    <hr>
                    <!-- <div class="row" *ngIf="!editpermission">
                    <div class="form-group col-md-12">
                        <label class="text-danger"> Sorry, You are not allowed to
                            submit new application since the previous is pending with Dental
                            Council of India. </label>
                         
                    </div>
                </div> -->
                    <div class="row">
                        <div class="form-group col-md-3">
                            <label>First Name <span class="aseticcolor">*</span></label>
                            <div class="row">
                                <div class="col-md-2.5">
                                    <h5 style="font-weight: bold;">Dr.</h5>&nbsp;
                                </div>
                                <div class="col-md-8.5">
                                    <input type="text" placeholder="First Name" class="form-control"
                                        formControlName="firstName" maxlength="70" [(ngModel)]="uidrDetails.firstName">
                                </div>
                            </div>
                            <div *ngIf="submitted && uidrRegistrationForm.controls['firstName'].hasError('required')"
                                class="failed-validation" class="errorColor">
                                First Name Required
                            </div>
                            <!-- <div *ngIf="uidrRegistrationForm.controls['firstName'].hasError('pattern')" class="failed-validation"
            class="errorColor">
            Invalid Student Name
        </div> -->

                        </div>
                        <div class="col-md-3">
                            <label>Middle Name </label>
                            <input type="text" placeholder="Middle Name" class="form-control"
                                formControlName="middleName" maxlength="70" [(ngModel)]="uidrDetails.middleName">
                            <!-- <div *ngIf="submitted && uidrRegistrationForm.controls['middleName'].hasError('required')"
                            class="failed-validation" class="errorColor">
                            Middle Name Required
                        </div> -->
                            <!-- <div *ngIf="uidrRegistrationForm.controls['middleName'].hasError('pattern')" class="failed-validation"
            class="errorColor">
            Invalid Student Name
        </div> -->

                        </div>
                        <div class="col-md-3">
                            <label>Last Name <span class="aseticcolor">*</span></label>
                            <input type="text" placeholder="Last Name" class="form-control" formControlName="lastName"
                                maxlength="70" [(ngModel)]="uidrDetails.lastName">
                            <div *ngIf="submitted && uidrRegistrationForm.controls['lastName'].hasError('required')"
                                class="failed-validation" class="errorColor">
                                Last Name Required
                            </div>
                            <div *ngIf="uidrRegistrationForm.controls['lastName'].hasError('pattern')"
                                class="failed-validation" class="errorColor">
                                Invalid Last Name
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label>Father's Name <span class="aseticcolor">*</span></label>
                            <input type="text" placeholder="Father's Name" class="form-control"
                                formControlName="fatherName" maxlength="70" [(ngModel)]="uidrDetails.fatherName">
                            <div *ngIf="submitted && uidrRegistrationForm.controls['fatherName'].hasError('required')"
                                class="failed-validation" class="errorColor">
                                Father's Name Required
                            </div>
                            <div *ngIf="uidrRegistrationForm.controls['fatherName'].hasError('pattern')"
                                class="failed-validation" class="errorColor">
                                Invalid Father's Name
                            </div>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 10px;">
                        <div class="col-md-3">
                            <label>Gender <span class="aseticcolor">*</span></label>
                            <select class="form-control" formControlName="gender" [(ngModel)]="uidrDetails.gender">
                                <option value="">Select Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="TransGender">TransGender</option>
                            </select>
                            <div *ngIf="submitted && uidrRegistrationForm.controls['gender'].hasError('required') "
                                class="failed-validation" class="errorColor">
                                Gender Required
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label>Date of Birth <span class="aseticcolor">*</span></label>
                            <input type="date" onkeydown="return false" placeholder="dd/mm/yyyy" class="form-control"
                                formControlName="dob" [(ngModel)]="uidrDetails.dateOfBirth" max="{{maxEndDate}}">
                            <div *ngIf="submitted && uidrRegistrationForm.controls['dob'].hasError('required')"
                                class="failed-validation" class="errorColor">
                                Date of Birth Required
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label>Email ID <span class="aseticcolor">*</span></label>
                            <input type="email" placeholder="Email ID" class="form-control" formControlName="email"
                                maxlength="255" [(ngModel)]="uidrDetails.email">
                            <div *ngIf="submitted && uidrRegistrationForm.controls['email'].hasError('required')"
                                class="failed-validation" class="errorColor">
                                Email ID Required
                            </div>
                            <div *ngIf="uidrRegistrationForm.controls['email'].hasError('pattern')"
                                class="failed-validation" class="errorColor">
                                Invalid Email ID
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label>Mobile Number <span class="aseticcolor">*</span></label>
                            <input type="text" placeholder="Mobile Number" class="form-control"
                                formControlName="mobileNumber" maxlength="10" (keypress)="keyPresspincode($event)"
                                (keypress)="keyPress($event)" data-validation-error-msg='Mobile Number is required'
                                data-validation-regexp="^[2-9][0-9]*$" data-validation="required length number custom"
                                data-validation-length="10-10" [(ngModel)]="uidrDetails.mobile">
                            <div *ngIf="submitted && uidrRegistrationForm.controls['mobileNumber'].hasError('required')"
                                class="failed-validation" class="errorColor">
                                Mobile Number Required
                            </div>
                            <div *ngIf="uidrRegistrationForm.controls['mobileNumber'].hasError('pattern')"
                                class="failed-validation" class="errorColor">
                                Mobile Number should have starts with 9,8,7,6 and length 10 digits
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-3">
                            <label>Nationality <span class="aseticcolor">*</span></label>
                            <input type="text" placeholder='Nationality' class="form-control"
                                formControlName="nationality" maxlength="70" disabled>
                        </div>
                        <div class="form-group col-md-4">
                            <label>Candidate Photo<span class="aseticcolor">*</span> </label>
                            <div
                                *ngIf="uidrDetails.candidatePhoto ===null || uidrDetails.candidatePhoto==='' || uidrDetails.candidatePhoto===undefined">
                                <input type="file" #myInput class="form-control" accept=".png,.jpg,.jpeg,gif,.tif"
                                    (change)="onSelectSDCCerificate($event,'candidatePhoto')">
                                <div style="white-space: nowrap;">
                                    (Max size.200 KB, file format .png,.jpg,.jpeg,gif,.tif only) *
                                </div>
                                <div *ngIf="submitted && uidrRegistrationForm.controls['candidatePhoto'].hasError('required')"
                                    class="failed-validation" class="errorColor">
                                    candidate Photo Required
                                </div>
                            </div>
                            <div
                                *ngIf="uidrDetails.candidatePhoto !==null && uidrDetails.candidatePhoto!=='' && uidrDetails.candidatePhoto!==undefined">

                                {{uidrDetails.candidatePhoto?.split('/').pop()}}
                                <span class="fas fa-times" style="color:red;font-size: 20px;cursor: pointer;"
                                    (click)="removedPhoto()"></span>

                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-md-6">
                            <h5 class="headingValue">Registration Details</h5>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="form-group col-md-3">
                            <label>First Registration SDC<span class="aseticcolor">*</span></label>
                            <select class="form-control" [formGroup]="uidrRegistrationForm"
                                [compareWith]="compareFnForSDC" formControlName="firstRegistrationStateId"
                                [(ngModel)]="uidrDetails.firstRegistrationState">
                                <option value="">Select</option>
                                <option *ngFor="let sdc of SDCList" [ngValue]="sdc">
                                    {{sdc.name}}</option>
                            </select>
                            <div *ngIf="submitted && uidrRegistrationForm.controls['firstRegistrationStateId'].hasError('required') "
                                class="failed-validation" class="errorColor">
                                First Registration SDC Required
                            </div>

                        </div>
                        <div class="form-group col-md-3">
                            <label>First Registration Date<span class="aseticcolor">*</span></label>
                            <input type="date" onkeydown="return false" placeholder="dd/mm/yyyy" class="form-control"
                                formControlName="firstRegistrationDate" [(ngModel)]="uidrDetails.firstRegistrationDate">
                            <div *ngIf="submitted && uidrRegistrationForm.controls['firstRegistrationDate'].hasError('required')"
                                class="failed-validation" class="errorColor">
                                First Registration Date Required
                            </div>
                        </div>
                        <div class="form-group col-md-3">
                            <label>First Registration Part</label><span class="aseticcolor">*</span>
                            <div>
                                <label class="i-checks"> <input type="radio" class="radiobox style-0"
                                        [(ngModel)]="uidrDetails.firstRegistrationPart"
                                        formControlName="firstRegistrationPart" value="A" ng-checked="true"> <i></i> A
                                </label>&nbsp;&nbsp;&nbsp;
                                <label class="i-checks"> <input type="radio" class="radiobox style-0"
                                        [(ngModel)]="uidrDetails.firstRegistrationPart"
                                        formControlName="firstRegistrationPart" value="B" ng-checked="true"> <i></i> B
                                </label>
                            </div>
                            <!-- <select class="form-control" formControlName="firstRegistrationPart"
                            [(ngModel)]="uidrDetails.firstRegistrationPart">
                            <option value="">Select</option>
                            <option value="A">A</option>
                            <option value="B">B</option>
                        </select> -->
                            <div *ngIf="submitted && uidrRegistrationForm.controls['firstRegistrationPart'].hasError('required') "
                                class="failed-validation" class="errorColor">
                                First Registration Part Required
                            </div>

                        </div>
                        <div class="form-group col-md-3">
                            <label>First Registration No. <span class="aseticcolor">*</span></label>

                            <input type="text" placeholder="First Registration Number" class="form-control"
                                formControlName="firstRegistrationNo" maxlength="20"
                                [(ngModel)]="uidrDetails.firstRegistrationNo" (keypress)="keyPressAlphaNumberic($event)"
                                (keypress)="keyPress($event)">
                            <div *ngIf="submitted && uidrRegistrationForm.controls['firstRegistrationNo'].hasError('required') "
                                class="failed-validation" class="errorColor">
                                First Registration Number Required
                            </div>
                            <div *ngIf="uidrRegistrationForm.controls['firstRegistrationNo'].hasError('pattern')"
                                class="failed-validation" class="errorColor">
                                Invalid First Registration No
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group col-md-3">
                            <label>Present Registration SDC<span class="aseticcolor">*</span> </label>
                            <select class="form-control" [formGroup]="uidrRegistrationForm"
                                formControlName="presentRegistrationStateId" [compareWith]="compareFnForSDC"
                                [(ngModel)]="uidrDetails.presentRegistrationState">
                                <option value="">Select</option>
                                <option *ngFor="let sdc of SDCList" [ngValue]="sdc">
                                    {{sdc.name}}</option>
                            </select>
                            <!-- <input type="text" placeholder='Present Registration State' class="form-control"
                            formControlName="presentRegistrationStateId" maxlength="70" > -->
                            <div *ngIf="submitted && uidrRegistrationForm.controls['presentRegistrationStateId'].hasError('required') "
                                class="failed-validation" class="errorColor">
                                Present Registration State Required
                            </div>
                        </div>
                        <div class="form-group col-md-3">
                            <label>Present Registration Date<span class="aseticcolor">*</span> </label>
                            <input type="date" onkeydown="return false" placeholder="dd/mm/yyyy" class="form-control"
                                formControlName="presentRegistrationDate"
                                [(ngModel)]="uidrDetails.presentRegistrationDate">
                            <div *ngIf="submitted && uidrRegistrationForm.controls['presentRegistrationDate'].hasError('required')"
                                class="failed-validation" class="errorColor">
                                Present Registration Date Required
                            </div>
                        </div>
                        <div class="form-group col-md-3">
                            <label>Present Registration Part<span class="aseticcolor">*</span></label>
                            <div>
                                <label class="i-checks"> <input type="radio" class="radiobox style-0"
                                        [(ngModel)]="uidrDetails.presentRegistrationPart"
                                        formControlName="presentRegistrationPart" value="A" ng-checked="true"> <i></i> A
                                </label>&nbsp;&nbsp;&nbsp;
                                <label class="i-checks"> <input type="radio" class="radiobox style-0"
                                        [(ngModel)]="uidrDetails.presentRegistrationPart"
                                        formControlName="presentRegistrationPart" value="B" ng-checked="true"> <i></i> B
                                </label>
                            </div>
                            <!-- <select class="form-control" formControlName="presentRegistrationPart"
                            [(ngModel)]="uidrDetails.presentRegistrationPart">
                            <option value="">Select</option>
                            <option value="A">A</option>
                            <option value="B">B</option>
                        </select> -->
                            <div *ngIf="submitted && uidrRegistrationForm.controls['presentRegistrationPart'].hasError('required') "
                                class="failed-validation" class="errorColor">
                                Present Registration Part Required
                            </div>
                        </div>
                        <div class="form-group col-md-3">
                            <label>Present Registration No.<span class="aseticcolor">*</span></label>
                            <input type="text" placeholder="Present Registration Number" class="form-control"
                                formControlName="presentRegistrationNo" maxlength="20"
                                [(ngModel)]="uidrDetails.presentRegistrationNo"
                                (keypress)="keyPressAlphaNumberic($event)" (keypress)="keyPress($event)">
                            <div *ngIf="submitted && uidrRegistrationForm.controls['presentRegistrationNo'].hasError('required') "
                                class="failed-validation" class="errorColor">
                                Present Registration Number Required
                            </div>
                            <div *ngIf="uidrRegistrationForm.controls['presentRegistrationNo'].hasError('pattern')"
                                class="failed-validation" class="errorColor">
                                Invalid Present Registration No
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-3">
                            <label>Valid Upto<span class="aseticcolor">*</span> </label>
                            <input type="date" onkeydown="return false" placeholder="dd/mm/yyyy" class="form-control"
                                formControlName="validUptoDate" [(ngModel)]="uidrDetails.validUptoDate" [min]="minDate">
                            <div *ngIf="submitted && uidrRegistrationForm.controls['validUptoDate'].hasError('required')"
                                class="failed-validation" class="errorColor">
                                Valid up to Required
                            </div>
                        </div>
                        <div class="form-group col-md-3">
                            <label>Upload Present SDC Certificate<span class="aseticcolor">*</span> </label>
                            <div
                                *ngIf="uidrDetails.presentSDCCerificate ===null || uidrDetails.presentSDCCerificate==='' || uidrDetails.presentSDCCerificate===undefined">
                                <input type="file" class="form-control" accept=".pdf"
                                    (change)="onSelectSDCCerificate($event,'presentSDCCerificate')">
                                <div>
                                    (Max size.200 KB, file format .pdf only) *
                                </div>
                                <div *ngIf="submitted && uidrRegistrationForm.controls['presentSDCCerificate'].hasError('required')"
                                    class="failed-validation" class="errorColor">
                                    Upload Present SDC Certificate Required
                                </div>
                            </div>
                            <div
                                *ngIf="uidrDetails.presentSDCCerificate !==null && uidrDetails.presentSDCCerificate!=='' && uidrDetails.presentSDCCerificate!==undefined">

                                {{uidrDetails.presentSDCCerificate?.split('/').pop()}}
                                <span class="fas fa-times" style="color:red;font-size: 20px;cursor: pointer;"
                                    (click)="removedpresentSDCCerificate()"></span>

                            </div>
                        </div>
                        <div class="form-group col-md-3">
                            <label>Presently Working <span class="aseticcolor">*</span> </label>
                            <select class="form-control" formControlName="presentWorking"
                                (change)="presentWorkingChange()" [(ngModel)]="uidrDetails.presentWorking">
                                <option value="">Select</option>
                                <option value="Faculty">Faculty</option>
                                <option value="Practitioner">Practitioner</option>
                                <option value="Dental Surgeon at Govt. service at">Dental Surgeon at Govt. service at
                                </option>
                                <option value="Other">Other</option>
                            </select>

                            <div *ngIf="submitted && uidrRegistrationForm.controls['presentWorking'].hasError('required')"
                                class="failed-validation" class="errorColor">
                                Presently Working Required
                            </div>
                        </div>
                        <div class="form-group col-md-3"
                            *ngIf="uidrDetails.presentWorking==='Practitioner' || uidrDetails.presentWorking==='Dental Surgeon at Govt. service at'">
                            <label>Area <span class="aseticcolor">*</span> </label>
                            <div>
                                <label class="i-checks"> <input type="radio" class="radiobox style-0"
                                        [(ngModel)]="uidrDetails.presentWorkingDetail"
                                        formControlName="presentWorkingDetail" value="Rural" ng-checked="true"> <i></i>
                                    Rural
                                </label>&nbsp;&nbsp;&nbsp;
                                <label class="i-checks"> <input type="radio" class="radiobox style-0"
                                        [(ngModel)]="uidrDetails.presentWorkingDetail"
                                        formControlName="presentWorkingDetail" value="Urban" ng-checked="true"> <i></i>
                                    Urban
                                </label>
                            </div>
                            <!-- <select class="form-control" formControlName="presentWorkingDetail"
                                [(ngModel)]="uidrDetails.presentWorkingDetail">
                                <option value="">Select</option>
                                <option value="Rural">Rural</option>
                                <option value="Urban">Urban</option>
                            </select> -->

                            <div *ngIf="submitted && uidrRegistrationForm.controls['presentWorkingDetail'].hasError('required')"
                                class="failed-validation" class="errorColor">
                                Presently Working detail Required
                            </div>
                        </div>
                        <div class="form-group col-md-3" *ngIf="uidrDetails.presentWorking==='Other'">
                            <label>Details<span class="aseticcolor">*</span> </label>
                            <input type="text" class="form-control" formControlName="presentWorkingDetail"
                                [(ngModel)]="uidrDetails.presentWorkingDetail">

                            <div *ngIf="submitted && uidrRegistrationForm.controls['presentWorkingDetail'].hasError('required')"
                                class="failed-validation" class="errorColor">
                                Other text Required
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-md-4">
                            <h5 class="headingValue">Qualification Details
                            </h5>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="table-responsive-sm">
                                <table class="table table-bordered table-hover" formArrayName="qualifications">
                                    <thead class="thead-light">
                                        <tr>
                                            <th>Degree Obtained</th>
                                            <th>Specialization</th>
                                            <th>Passing Year</th>
                                            <th>Institution Name</th>
                                            <th>University Name</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr [formGroupName]="i"
                                            *ngFor="let uidrQualification of uidrDetails.qualificationList;let i = index;"
                                            style="cursor: pointer;">
                                            <td><select class="form-control" [compareWith]="compareFnForCourse"
                                                    class="form-control" formControlName="course"
                                                    [(ngModel)]="uidrQualification.collegeCourse">
                                                    <option value="" disabled selected>Select Course</option>
                                                    <option *ngFor="let course of courseList" [ngValue]="course">
                                                        {{course.courseName}}</option>
                                                </select>
                                                <div *ngIf="qualificationsubmitted && qualifications.controls[i].get('course')?.errors?.required"
                                                    class="failed-validation" class="errorColor">
                                                    Course Required
                                                </div>
                                            </td>
                                            <td><select class="form-control" class="form-control"
                                                    [compareWith]="compareFn" formControlName="specialisation"
                                                    [(ngModel)]="uidrQualification.collegeSpecialisation">
                                                    <option value="" selected>Select Specialization</option>
                                                    <option
                                                        *ngFor="let specializations of filterbycollegeCourseId(uidrQualification.collegeCourse,i)"
                                                        [ngValue]="specializations">
                                                        {{specializations.name}}</option>
                                                </select>
                                                <div *ngIf="qualificationsubmitted && qualifications.controls[i].get('specialisation')?.errors?.required"
                                                    class="failed-validation" class="errorColor">
                                                    Specialization Required
                                                </div>
                                            </td>
                                            <td>
                                                <select class="form-control" formControlName="passingYear"
                                                    [(ngModel)]="uidrQualification.passingYear">
                                                    <option value="" selected>Select</option>
                                                    <option *ngFor="let item of yearList" [value]="item.text">
                                                        {{item.text}}</option>
                                                </select>
                                                <div *ngIf="qualificationsubmitted && qualifications.controls[i].get('passingYear')?.errors?.required"
                                                    class="failed-validation" class="errorColor">
                                                    Specialization Required
                                                </div>
                                            </td>
                                            <td>
                                                <select class="form-control" formControlName="institution"
                                                    [(ngModel)]="uidrQualification.institution.collegeId"
                                                    (change)="otherInsitutionChange(i)">
                                                    <option value="" selected>Select</option>
                                                    <option *ngFor="let item of collegeList" [value]="item.collegeId">
                                                        {{item.collegeName}}</option>
                                                    <option value="Other">Other</option>
                                                </select>
                                                <div *ngIf="qualificationsubmitted && qualifications.controls[i].get('institution')?.errors?.required"
                                                    class="failed-validation" class="errorColor">
                                                    Insitution Name Required
                                                </div>
                                                <input *ngIf="uidrQualification.institution==='Other'" type="text"
                                                    placeholder="Other Insitution Name" class="form-control"
                                                    formControlName="otherInsitutionName" maxlength="70"
                                                    [(ngModel)]="uidrQualification.otherInsitutionName">

                                                <div *ngIf="qualificationsubmitted && qualifications.controls[i].get('otherInsitutionName')?.errors?.required"
                                                    class="failed-validation" class="errorColor">
                                                    Other Insitution Name Required
                                                </div>
                                            </td>
                                            <td>
                                                <select class="form-control" formControlName="university"
                                                    [(ngModel)]="uidrQualification.university.universityId"
                                                    (change)="otherUniversityChange(i)">
                                                    <option value="" selected>Select</option>
                                                    <option *ngFor="let item of universityList"
                                                        [value]="item.universityId">
                                                        {{item.universityName}}</option>
                                                    <option value="Other">Other</option>
                                                </select>
                                                <div *ngIf="qualificationsubmitted && qualifications.controls[i].get('university')?.errors?.required"
                                                    class="failed-validation" class="errorColor">
                                                    University Name Required
                                                </div>
                                                <input *ngIf="uidrQualification.university==='Other'" type="text"
                                                    placeholder="University Name" class="form-control"
                                                    formControlName="otherUniversityName" maxlength="70"
                                                    [(ngModel)]="uidrQualification.otherUniversityName">
                                                <div *ngIf="qualificationsubmitted && qualifications.controls[i].get('otherUniversityName')?.errors?.required"
                                                    class="failed-validation" class="errorColor">
                                                    Other University Name Required
                                                </div>
                                            </td>
                                            <td>
                                                <div class="btn btn-sm btn-success" (click)="addQualification(i)">
                                                    <span class="fa fa-plus"></span>
                                                </div>&nbsp;&nbsp;
                                                <div *ngIf="i>0" class="btn btn-sm btn-danger"
                                                    (click)="deleteQualification(i)">
                                                    <span class="fa fa-minus"></span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-md-6">
                            <h5 class="headingValue">Correspondence Address
                            </h5>
                        </div>
                    </div>
                    <br>
                    <div class="row">

                        <div class="form-group col-md-4">
                            <label>Address Line 1 <span class="aseticcolor">*</span></label>
                            <input type="text" placeholder="Address Line 1" class="form-control"
                                formControlName="correspondenceAddressLine1"
                                [(ngModel)]="uidrDetails.correspondenceAddressLine1">
                            <div *ngIf="submitted && uidrRegistrationForm.controls['correspondenceAddressLine1'].hasError('required') "
                                class="failed-validation" class="errorColor">
                                Address Line 1 Required
                            </div>
                            <div *ngIf="uidrRegistrationForm.controls['correspondenceAddressLine1'].hasError('pattern')"
                                class="failed-validation" class="errorColor">
                                Invalid Address Line 1
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <label>Address Line 2
                                <span class="aseticcolor">*</span></label>
                            <input type="text" placeholder="Address Line 2" class="form-control"
                                formControlName="correspondenceAddressLine2"
                                [(ngModel)]="uidrDetails.correspondenceAddressLine2">
                            <div *ngIf="submitted && uidrRegistrationForm.controls['correspondenceAddressLine2'].hasError('required')"
                                class="failed-validation" class="errorColor">
                                Address Line 2 Required
                            </div>
                            <div *ngIf="uidrRegistrationForm.controls['correspondenceAddressLine2'].hasError('pattern')"
                                class="failed-validation" class="errorColor">
                                Invalid Address Line 2
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <label>Country <span class="aseticcolor">*</span></label>
                            <select class="form-control" [(ngModel)]="uidrDetails.correspondenceAddressCountry"
                                formControlName="correspondenceAddressCountry">
                                <option value="" disabled>Select State/UT</option>
                                <option *ngFor="let country of countryList" [value]="country.countryId">
                                    {{country.countryName}}</option>
                            </select>
                            <div *ngIf="submitted && uidrRegistrationForm.controls['correspondenceAddressCountry'].hasError('required')"
                                class="failed-validation" class="errorColor">
                                Country Required
                            </div>
                        </div>

                    </div>

                    <div class="row">
                        <div class="form-group col-md-4">
                            <label>State/UT <span class="aseticcolor">*</span></label>
                            <select class="form-control" [(ngModel)]="uidrDetails.correspondenceAddressState"
                                formControlName="correspondenceAddressState" *ngIf="uidrDetails.correspondenceAddressCountry===1"
                                (change)="getCities($event.target.value,'correspondenceAddressState','')">
                                <option value="" disabled>Select State/UT</option>
                                <option *ngFor="let states of statesList" [value]="states.stateId">
                                    {{states.stateName}}</option>
                            </select>
                            <input type="text" class="form-control" [(ngModel)]="uidrDetails.correspondenceAddressOtherState"
                                formControlName="correspondenceAddressState" *ngIf="uidrDetails.correspondenceAddressCountry!==1" />

                            <div *ngIf="submitted && uidrRegistrationForm.controls['correspondenceAddressState'].hasError('required')"
                                class="failed-validation" class="errorColor">
                                State/UT Required
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <label>City <span class="aseticcolor">*</span></label>
                            <select class="form-control" formControlName="correspondenceAddressCity"
                                [(ngModel)]="uidrDetails.correspondenceAddressCity"  *ngIf="uidrDetails.correspondenceAddressCountry ===1" >
                                <option value="" disabled selected>Select City</option>
                                <option *ngFor="let city of corescitiesList" [value]="city.cityId">
                                    {{city.cityName}}</option>
                            </select>
                            <input type="text" class="form-control" [(ngModel)]="uidrDetails.correspondenceAddressOtherCity"
                            formControlName="correspondenceAddressCity" *ngIf="uidrDetails.correspondenceAddressCountry!==1" />

                            <div *ngIf="submitted && uidrRegistrationForm.controls['correspondenceAddressCity'].hasError('required')"
                                class="failed-validation" class="errorColor">
                                City Required
                            </div>
                        </div>

                        <div class="form-group col-md-4">
                            <label>Pin Code </label>
                            <input type="text" placeholder="Pin Code" class="form-control"
                                formControlName="correspondenceAddressPincode"
                                [(ngModel)]="uidrDetails.correspondenceAddressPincode" maxlength="6" minlength="6"
                                (keypress)="keyPresspincode($event)">
                            <!-- <div *ngIf="submitted && uidrRegistrationForm.controls['correspondenceAddressPincode'].hasError('required')"
                            class="failed-validation" class="errorColor">
                            PinCode Required
                        </div> -->
                            <div *ngIf="uidrRegistrationForm.controls['correspondenceAddressPincode'].hasError('pattern')"
                                class="failed-validation" class="errorColor">
                                Invalid PinCode
                            </div>
                        </div>
                    </div>
                    <hr>
                    <!-- <h6>IF PRESENT ADDRESS IS PERMANENT ADDRESS</h6> -->
                    <div class="row">
                        <div class="form-group col-md-12">
                            <h5 class="headingValue">Permanent Address</h5>&nbsp;

                            <input type="checkbox" id="vehicle1" name="address" formControlName="address"
                                (change)="checkbox($event)">&nbsp;
                            <label for="address">Same As Current Address</label>
                        </div>
                    </div>
                    <br>
                    <!-- <div class="row" *ngIf="show"> -->
                    <div class="row">


                        <div class="form-group col-md-4">
                            <label>Address Line 1 <span class="aseticcolor">*</span></label>
                            <input type="text" placeholder="Address Line 1" class="form-control"
                                formControlName="permanentAddressLine1" [(ngModel)]="uidrDetails.permanentAddressLine1"
                                maxlength="70">
                            <div *ngIf="submitted && uidrRegistrationForm.controls['permanentAddressLine1'].hasError('required')"
                                class="failed-validation" class="errorColor">
                                Address Line 1 Required
                            </div>
                            <div *ngIf="uidrRegistrationForm.controls['permanentAddressLine1'].hasError('pattern')"
                                class="failed-validation" class="errorColor">
                                Invalid Address Line 1
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <label>Address Line 2 <span class="aseticcolor">*</span></label>
                            <input type="text" placeholder="Address Line 2" class="form-control"
                                formControlName="permanentAddressLine2" [(ngModel)]="uidrDetails.permanentAddressLine2"
                                maxlength="70">
                            <div *ngIf="submitted && uidrRegistrationForm.controls['permanentAddressLine2'].hasError('required')"
                                class="failed-validation" class="errorColor">
                                Address Line 2 Required
                            </div>
                            <div *ngIf="uidrRegistrationForm.controls['permanentAddressLine2'].hasError('pattern')"
                                class="failed-validation" class="errorColor">
                                Invalid Address Line 2
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <label>Country <span class="aseticcolor">*</span></label>
                            <select class="form-control" [(ngModel)]="uidrDetails.permanentAddressCountry"
                                formControlName="permanentAddressCountry">
                                <option value="" disabled>Select State/UT</option>
                                <option *ngFor="let country of countryList" [value]="country.countryId">
                                    {{country.countryName}}</option>
                            </select>
                            <div *ngIf="submitted && uidrRegistrationForm.controls['permanentAddressCountry'].hasError('required')"
                                class="failed-validation" class="errorColor">
                                Country Required
                            </div>
                        </div>
                     
                    </div>
                    <br>
                    <!-- <div class="row" *ngIf="show"> -->
                    <div class="row">
                        <div class="form-group col-md-4">
                            <label>State/UT <span class="aseticcolor">*</span></label>
                            <select class="form-control" *ngIf="uidrDetails.permanentAddressCountry===1" formControlName="permanentAddressState"
                                (change)="getCities($event.target.value,'permanentAddressState','')"
                                [(ngModel)]="uidrDetails.permanentAddressState">
                                <option value="" disabled>Select State/UT</option>
                                <option *ngFor="let states of statesList" [value]="states.stateId">
                                    {{states.stateName}}</option>
                            </select>
                            <input type="text" class="form-control" [(ngModel)]="uidrDetails.permanentAddressOtherState"
                                formControlName="permanentAddressState" *ngIf="uidrDetails.permanentAddressCountry!==1" />

                            <div *ngIf="submitted && uidrRegistrationForm.controls['permanentAddressState'].hasError('required')"
                                class="failed-validation" class="errorColor">
                                State/UT Required
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <label>City <span class="aseticcolor">*</span></label>
                            <select class="form-control" formControlName="permanentAddressCity"
                                [(ngModel)]="uidrDetails.permanentAddressCity" *ngIf="uidrDetails.permanentAddressCountry===1">
                                <option value="" disabled selected>Select City</option>
                                <option *ngFor="let city of permanentcitiesList" [value]="city.cityId">
                                    {{city.cityName}}</option>
                            </select>
                            <input type="text" class="form-control" [(ngModel)]="uidrDetails.permanentAddressOtherCity"
                            formControlName="permanentAddressCity" *ngIf="uidrDetails.permanentAddressCountry!==1" />

                            <div *ngIf="submitted && uidrRegistrationForm.controls['permanentAddressCity'].hasError('required')"
                                class="failed-validation" class="errorColor">
                                City Required
                            </div>
                        </div>

                        <div class="form-group col-md-4">
                            <label>Pin Code </label>
                            <input type="text" placeholder="Pin Code" class="form-control"
                                formControlName="permanentAddressPincode"
                                [(ngModel)]="uidrDetails.permanentAddressPincode" maxlength="6" minlength="6"
                                (keypress)="keyPresspincode($event)" formControlName="permanentAddressPincode">
                            <!-- <div *ngIf="uidrRegistrationForm.controls['permanentAddressPincode'].hasError('required') && uidrRegistrationForm.controls['permanentAddressPincode'].touched"
                            class="failed-validation" class="errorColor">
                            PinCode Required
                        </div> -->
                            <div *ngIf="uidrRegistrationForm.controls['permanentAddressPincode'].hasError('pattern')"
                                class="failed-validation" class="errorColor">
                                Invalid PinCode
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-md-6">
                            <h5 class="headingValue">Professional Address
                            </h5>
                        </div>
                    </div>
                    <br>
                    <div class="row">


                        <div class="form-group col-md-4">
                            <label>Address Line 1 <span class="aseticcolor">*</span></label>
                            <input type="text" placeholder="Address Line 1" class="form-control"
                                formControlName="professionalAddressLine1"
                                [(ngModel)]="uidrDetails.professionalAddressLine1">
                            <div *ngIf="submitted && uidrRegistrationForm.controls['professionalAddressLine1'].hasError('required')"
                                class="failed-validation" class="errorColor">
                                Address Line 1 Required
                            </div>
                            <div *ngIf="uidrRegistrationForm.controls['professionalAddressLine1'].hasError('pattern')"
                                class="failed-validation" class="errorColor">
                                Invalid Address Line 1
                            </div>
                        </div>

                        <div class="form-group col-md-4">
                            <label>Address Line 2 <span class="aseticcolor">*</span></label>
                            <input type="text" placeholder="Address Line 2" class="form-control"
                                formControlName="professionalAddressLine2"
                                [(ngModel)]="uidrDetails.professionalAddressLine2">
                            <div *ngIf="submitted && uidrRegistrationForm.controls['professionalAddressLine2'].hasError('required')"
                                class="failed-validation" class="errorColor">
                                Address Line 2 Required
                            </div>
                            <div *ngIf="uidrRegistrationForm.controls['professionalAddressLine2'].hasError('pattern')"
                                class="failed-validation" class="errorColor">
                                Invalid Address Line 2
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <label>Country <span class="aseticcolor">*</span></label>
                            <select class="form-control" [(ngModel)]="uidrDetails.professionalAddressCountry"
                                formControlName="professionalAddressCountry">
                                <option value="" disabled>Select State/UT</option>
                                <option *ngFor="let country of countryList" [value]="country.countryId">
                                    {{country.countryName}}</option>
                            </select>
                            <div *ngIf="submitted && uidrRegistrationForm.controls['professionalAddressCountry'].hasError('required')"
                                class="failed-validation" class="errorColor">
                                Country Required
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-4">
                            <label>State/UT <span class="aseticcolor">*</span></label>
                            <select class="form-control" formControlName="professionalAddressState" *ngIf="uidrDetails.professionalAddressCountry===1" 
                                (change)="getCities($event.target.value,'professionalAddressState',null)"
                                [(ngModel)]="uidrDetails.professionalAddressState">
                                <option value="" disabled>Select State/UT</option>
                                <option *ngFor="let states of statesList" [value]="states.stateId">
                                    {{states.stateName}}</option>
                            </select>
                            <input type="text" class="form-control" [(ngModel)]="uidrDetails.professionalAddressOtherState"
                            formControlName="professionalAddressState" *ngIf="uidrDetails.professionalAddressCountry!==1" />

                            <div *ngIf="submitted && uidrRegistrationForm.controls['professionalAddressState'].hasError('required')"
                                class="failed-validation" class="errorColor">
                                State/UT Required
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <label>City <span class="aseticcolor">*</span></label>
                            <select class="form-control" formControlName="professionalAddressCity"
                                [(ngModel)]="uidrDetails.professionalAddressCity"  *ngIf="uidrDetails.professionalAddressCountry===1">
                                <option value="" disabled selected>Select City</option>
                                <option *ngFor="let city of professionalcitiesList" [value]="city.cityId">
                                    {{city.cityName}}</option>
                            </select>
                            <input type="text" class="form-control" [(ngModel)]="uidrDetails.professionalAddressOtherCity"
                            formControlName="professionalAddressCity" *ngIf="uidrDetails.professionalAddressCountry!==1" />

                            <div *ngIf="submitted && uidrRegistrationForm.controls['professionalAddressCity'].hasError('required')"
                                class="failed-validation" class="errorColor">
                                City Required
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <label>Pin Code </label>
                            <input type="text" placeholder="Pin Code" class="form-control"
                                formControlName="professionalAddressPincode" maxlength="6" minlength="6"
                                (keypress)="keyPresspincode($event)"
                                [(ngModel)]="uidrDetails.professionalAddressPincode">
                            <!-- <div *ngIf="uidrRegistrationForm.controls['professionalAddressPincode'].hasError('required') "
                            class="failed-validation" class="errorColor">
                            PinCode Required
                        </div> -->
                            <div *ngIf="uidrRegistrationForm.controls['professionalAddressPincode'].hasError('pattern')"
                                class="failed-validation" class="errorColor">
                                Invalid PinCode
                            </div>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 10px;">
                        <div class="col-md-12" align="right">
                            <button type="button" class="btn btn-primary" style="cursor: pointer;"
                                (click)="saveUIDRRegistration()">Save</button>&nbsp;&nbsp;
                            <button type="button" class="btn btn-danger" style="cursor: pointer;"
                                (click)="back()">Cancel</button>&nbsp;&nbsp;&nbsp;
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</header>